module.exports = __webpack_public_path__ + "static/media/ind_rail.71af279a.png";